'use client';
import { useState } from 'react';
import { WXShare } from '../../SDK';
import { useLocale, useTranslations } from 'use-intl';
import { useWechat } from '@ssv-website/hooks';
import { MessagePlugin } from 'tdesign-react';
import copy from 'copy-to-clipboard';
const logo = 'https://cdn-digital.ssv.qq.com/upload//s2024/s-logo.png';

export const Share = () => {
  const [showShare, setShowShare] = useState(false);
  const { isWechat } = useWechat();
  const t = useTranslations('s2025');
  const locale = useLocale();
  const shareTitle = t('shareTitle');

  // 点击分享
  const onShare = async () => {
    if (isWechat) {
      setShowShare(true);
      return;
    }

    const url = window.location.href;

    if (window.navigator.share) {
      window.navigator.share({
        title: shareTitle,
        text: shareTitle,
        url,
      });

      return;
    }
    // 兜底复制链接
    copy(url);
    MessagePlugin.success({
      content: t('复制链接成功'),
      duration: 1000,
    });
  };
  const bgName = `share-btn-${locale === 'en' ? 'en1' : 'zh'}`;
  return (
    <>
      <div
        className="size-[72px] cursor-pointer fixed bottom-[172px] right-[80px] mobile:right-2 mobile:bottom-28 z-20"
        onClick={() => {
          onShare();
        }}
        style={{
          background: `url(https://cdn-digital.ssv.qq.com/upload//s2025/${
            bgName || 'share-btn-zh'
          }.png) no-repeat left top / 100% 100%`,
        }}
      ></div>
      {/* 分享指引 */}
      {showShare && (
        <div
          className="fixed left-0 top-0 w-full h-full z-[9999] bg-[#000000]/80"
          onClick={() => setShowShare(false)}
        >
          <div className="absolute ritght-[44px] top-[70px] w-full flex flex-col px-11">
            <div
              className="w-[85px] h-[106px] self-end"
              style={{
                background: `url(https://cdn-digital.ssv.qq.com/upload//s2025/share-arrow.png) no-repeat left top / 100% 100%`,
              }}
            ></div>
            <div className="text-white self-end text-base mt-[18px]">
              <p className="mb-3">1、{t('share-1')}</p>
              <p className="inline-flex items-center whitespace-nowrap">
                2、{t('share-2-1')}
                <i
                  className="size-12 mx-[10px]"
                  style={{
                    background:
                      'url(https://cdn-digital.ssv.qq.com/upload//s2025/share-icon-1.png) no-repeat left top / 100% 100%',
                  }}
                ></i>
                {t('share-2-2')}
                <i
                  className="size-12 mx-[10px]"
                  style={{
                    background:
                      'url(https://cdn-digital.ssv.qq.com/upload//s2025/share-icon-2.png) no-repeat left top / 100% 100%',
                  }}
                ></i>
                {t('share-2-3')}
              </p>
            </div>
          </div>
        </div>
      )}
      <WXShare shareTitle={shareTitle} shareDesc={shareTitle} shareImg={logo} />
    </>
  );
};
